export enum StockTypeStatus {
    Anticipated = 'anticipated',
    SaleOrder = 'SaleOrder',
    dummy = 'dummy',
    superDummy = 'superDummy',
}   